import React from "react";
import { MessageCircle, Mail } from "lucide-react";
import {
  WHATSAPP_DISPLAY,
  CONTACT_EMAIL,
  MARHABA_LOGO_URL,
  buildWhatsAppLink,
  DEFAULT_WA_MESSAGE,
} from "../lib/constants";

const QUICK_LINKS = [
  { href: "#paths", label: "الخدمات" },
  { href: "#offers", label: "الاستشارة · 100€" },
  { href: "#offers", label: "الدعم الكامل · 500€" },
  { href: "#faq", label: "الأسئلة الشائعة" },
  { href: "#lead-form", label: "تحقق من مسارك" },
];

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      className="bg-white border-t border-slate-200"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-tajawal text-2xl font-extrabold text-slate-900 tracking-tight mb-3">
              iqama<span className="text-emerald-600">.pl</span>
            </div>
            <p className="text-slate-600 text-sm leading-relaxed max-w-md">
              نساعد من يقيم حالياً في بولندا أو يخطط للعيش فيها على اختيار
              مسار الإقامة المناسب، والسير في الإجراءات بوضوح وبأقل المخاطر.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-tajawal text-sm font-bold text-slate-900 mb-4 uppercase tracking-wider">
              روابط سريعة
            </h4>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map((l, i) => (
                <li key={i}>
                  <a
                    href={l.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(l.href);
                    }}
                    className="text-sm text-slate-600 hover:text-emerald-700 transition-colors"
                    data-testid={`footer-link-${i}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-tajawal text-sm font-bold text-slate-900 mb-4 uppercase tracking-wider">
              تواصل معنا
            </h4>
            <div className="space-y-3">
              <a
                href={buildWhatsAppLink(DEFAULT_WA_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-slate-700 hover:text-emerald-700 transition-colors"
                data-testid="footer-whatsapp"
              >
                <span className="w-9 h-9 rounded-lg bg-[#25D366]/10 text-[#1DA851] flex items-center justify-center">
                  <MessageCircle className="w-4 h-4" />
                </span>
                <bdi dir="ltr" className="font-medium">{WHATSAPP_DISPLAY}</bdi>
              </a>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="flex items-center gap-3 text-sm text-slate-700 hover:text-emerald-700 transition-colors"
                data-testid="footer-email"
              >
                <span className="w-9 h-9 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center">
                  <Mail className="w-4 h-4" />
                </span>
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} iqama.pl — جميع الحقوق محفوظة.
          </p>
          <a
            href="https://marhaba.pl"
            target="_blank"
            rel="noopener noreferrer"
            dir="ltr"
            className="flex items-center gap-3 group"
            data-testid="powered-by-marhaba"
            aria-label="Powered by Marhaba Poland"
          >
            <span className="text-xs text-slate-500 group-hover:text-slate-700 transition-colors">
              Powered by
            </span>
            <img
              src={MARHABA_LOGO_URL}
              alt="Marhaba Poland"
              className="h-8 w-auto opacity-90 group-hover:opacity-100 transition-opacity"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}
